import { render, staticRenderFns } from "./compEditAccount.vue?vue&type=template&id=c6032fdc&scoped=true"
import script from "./compEditAccount.vue?vue&type=script&lang=js"
export * from "./compEditAccount.vue?vue&type=script&lang=js"
import style0 from "./compEditAccount.vue?vue&type=style&index=0&id=c6032fdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6032fdc",
  null
  
)

export default component.exports